import { PixelEventNames } from './PixelEventNames';

export interface PixelEventTotal {
  name: PixelEventNames;
  latest: number;
  total: number;
}

export const examplePixelEventTotal: PixelEventTotal = {
  name: PixelEventNames.AddPaymentInfo,
  latest: 1622054656,
  total: 10,
};
